import React from 'react'

import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import DateDisplay from '../../../../../../components/DateDisplay'
import { CandidateResumeReviewById } from 'src/queries'

interface ListProps {
  candidate: CandidateResumeReviewById | undefined
}

const List: React.FC<ListProps> = (props) => {
  const { candidate } = props
  const section: Array<Omit<ItemProps, 'id'>> = [
    {
      title: 'Sent',
      value: <DateDisplay id='sent_on' date={candidate?.resume?.sent} />
    },
    {
      title: 'Reviewed',
      value: <DateDisplay id='feedback_on' date={candidate?.resume?.reviewed} />
    },
    { title: 'Reviewed By', value: candidate?.resume?._reviewed_by?.name },
    { title: 'Rank', value: candidate?._rank?.name }
  ]
  const dlProps = {
    className: 'row-cols-1',
    suspended: candidate === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <DescriptionList {...dlProps}>
      {section.map(item => {
        const key = item.title.toLowerCase().replace(' ', '-')
        return <Item {...item} key={key} id={key} />
      })}
    </DescriptionList>
  )
}

export default List
